export const DEFAULT_DATE_FORMAT = 'DD.MM.YYYY';
export const NULL_DATE_STRING = '-';
